
riot.tag2('eventlist', '<ul> <li if="{events == null}">Loading Events</li> <li if="{events.length == 0}">No Upcoming Events</li> <li each="{events}"><a href="#" onclick="{showmodal}">{name || \'Untitled Event\'}</a><br><small riot-tag="dateformat" format="dd/MM/yyyy" date="{next}"></small> @ {cal}</li> </ul>', '', '', function(opts) {
this.showmodal = (function(_this) {
  return function(e) {
    return opts.viewevent(e.item);
  };
})(this);

this.events = [];

this.on('update', (function(_this) {
  return function() {
    var currDate;
    if (!opts.events) {
      return;
    }
    _this.events = [];
    currDate = opts.current || new Date();
    opts.events.forEach(function(evt, index) {
      evt.next = _this.nextDate(evt.dates, currDate);
      if (evt.next >= currDate) {
        return _this.events.push(evt);
      }
    });
    _this.events.sort(function(a, b) {
      return a.next - b.next;
    });
    if (opts.limit > 0) {
      return _this.events = _this.events.splice(0, opts.limit);
    }
  };
})(this));

this.nextDate = (function(_this) {
  return function(dateArray, currentDate) {
    var date, i, len;
    if (!dateArray) {
      return null;
    }
    for (i = 0, len = dateArray.length; i < len; i++) {
      date = dateArray[i];
      if (date > currentDate) {
        return date;
      }
    }
  };
})(this);
});